import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, FormControl, TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import Snackbars from "components/Snackbar/Snackbar.js";
import { useForm } from "hooks/useForm";
import { useTableSgcConfigurationsConfig } from "./hooks";
import { SgcConfigurationsSelectStation } from "./SgcConfigurationsSelectStation";
import { typeOptions } from "./config";
import {
  deleteSgcConfiguration,
  createNewSgcConfiguration,
  editSgcConfiguration
} from "redux/actions/sgcConfigurations/sgcConfigurationsAction";

const blue = "#0055aa";

export const FormSgcConfiguration = memo((props) => {
  const { handleClose } = props;
  const {
    setSnackBar,
    clearSnackBar,
  } = useTableSgcConfigurationsConfig();
  const { sgcConfigurationSelected, addMode, deleteMode, station, snackBar } = useSelector(({ sgcConfigurations }) => sgcConfigurations);

  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    name: "",
    type: null,
    value: "",
    defaultValue: "",
    description: ""
  });
  const { name, type, value, defaultValue, description } = inputValues;
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (name.length > 0 && station?.id && type?.value && value.length && defaultValue.length && description.length) {
      const newValues = {
        ...sgcConfigurationSelected,
        idStation: station.id,
        name,
        type: type.value,
        value,
        defaultValue,
        description
      };

      if (deleteMode) {
        dispatch(deleteSgcConfiguration(newValues));
        handleClose();
        return;
      }

      if (addMode) dispatch(createNewSgcConfiguration(newValues));
      else dispatch(editSgcConfiguration(newValues));
      handleClose();
    } else {
      setSnackBar("Campos con * son requeridos");
    }
  };

  useEffect(() => {
    if (sgcConfigurationSelected?.id) {
      handleNewValues({
        ...inputValues,
        name: sgcConfigurationSelected.name,
        type: typeOptions.find(type => type.value === sgcConfigurationSelected.type),
        value: sgcConfigurationSelected.value,
        defaultValue: sgcConfigurationSelected.defaultValue,
        description: sgcConfigurationSelected.description,
      });
    }
    // eslint-disable-next-line
  }, [sgcConfigurationSelected]);

  return (
    <>
      <FormControl fullWidth style={{ display: "flex", gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
        <SgcConfigurationsSelectStation size="medium" />
        <TextField type="text" label="Nombre *" name="name" value={name} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <Autocomplete
          id="combo-box-demo"
          options={typeOptions}
          value={type}
          filterSelectedOptions
          disabled={deleteMode}
          getOptionLabel={(option) => option.label ? option.label : option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              name="type"
              label="Tipo"
              variant="outlined"
              disabled={deleteMode}
            />
          )}
          fullWidth
          onChange={(e, v) => handleNewValues({
            ...inputValues,
            type: v
          })}
          noOptionsText="No se encuentran tipos"
        />
        <TextField type="text" label="Valor *" name="value" value={value} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="text" label="Valor Por Defecto *" name="defaultValue" value={defaultValue} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField
          minRows={3}
          multiline
          fullWidth
          variant="outlined"
          label="Descripción *"
          name="description"
          value={description}
          onChange={handleInputOnChange}
          disabled={deleteMode}
        />
        <Box sx={{ display: "flex", flexDirection: "column", marginTop: 30 }}>
          <RegularButton
            variant="contained"
            color="facebook"
            style={{ backgroundColor: blue, color: "white" }}
            onClick={handleSubmit}
          >
            {
              addMode
                ? "Agregar"
                : deleteMode ? "Eliminar"
                : "Guardar"
            }
          </RegularButton>
          <RegularButton variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
        </Box>
      </FormControl>
      <Snackbars
        place="tr"
        color="danger"
        message={snackBar.msg}
        open={snackBar.isOpen}
        closeNotification={clearSnackBar}
        close
      />
    </>
  );
});
